import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

class DialogData {
}

@Component({
  selector: 'app-attach-file-dialog',
  templateUrl: './attach-file-dialog.component.html',
  styleUrls: ['./attach-file-dialog.component.css']
})
export class AttachFileDialogComponent implements OnInit {

  fileToUpload: File = null;

  constructor(public dialogRef: MatDialogRef<AttachFileDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }

  processaFile(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  upload() {
    this.dialogRef.close(this.fileToUpload); // passo al chiamante il file scelto.
  }

  cancel() {
    this.dialogRef.close();
  }
}
